/*
Version 0.110

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2018
	08-03-2019
	- [CHANGE] Added variable check to set height and with when not given in on windowResize();
	11-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_interactions_window = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	// none
	
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
		/**
		Window: resize
		**/
		this.windowResize = function(scrolled,h,w) {
			
			/*
			Set: Variables
			*/
			if(typeof h === 'undefined') {
				h = $(window).height();
			}
			if(typeof w === 'undefined') {
				w = $(window).width();
			}

			// document.querySelector(':root').style.setProperty('--vh', window.innerHeight/100 + 'px');
			
		};
		
		/**
		Window: scroll
		**/
		this.windowScroll = function(scrolled,h,w) {

			/*
			Scrolled navigation
			*/
			if(w > 500) {
				if(scrolled >= 100) {
					
					if(_fixed_shown == 0) {
					
						$('header.desktop').stop().animate({
							'top':-200
						},400);

						_fixed_shown = 1;

					}


				} else {

					if(_fixed_shown == 1) {

						$('header.desktop').stop().animate({
							'top':0
						},400);

						_fixed_shown = 0;

					}

				}
			}

			/*
		    Set Celebrus on percentage of scrolling
		    Set Celebrus on percentage of scrolling
		    Set Celebrus on percentage of scrolling
		    Set Celebrus on percentage of scrolling
		    */
		    setTimeout(function() {

		    	if(_marcsenseretain_active == 1) {

			    	/*
			    	Scroll percentage
			    	*/
			    	var scrollTop 				= $(window).scrollTop();
					var docHeight 				= $(document).height();
					var winHeight 				= $(window).height();
					var scrollPercent 			= (scrollTop) / (docHeight - winHeight);
					var scrollPercentRounded 	= Math.round(scrollPercent*100);

					/*
			    	Trigger elements is in view?
			    	*/
			    	for (i = 0; i < 10; i++) {

						var _element 		= $('.js-scrollinview-' + i.toString());

						if(_element.length > 0 ) {

							var _position		= _element.get(0).getBoundingClientRect();

							specific_interactions_window.isInView(
								_element,
								_position,
								scrollPercentRounded
							);

						}

					}
					
					/*
					Scrolldingen
					*/
					// Video Homepage S
					// Video Hoe het werkt S
					// Voordelen S
					// Berekening S
					// Berekening gedaan
					// Footer / CTA
					// Dit is wat we weten popup

				}

			},200);

		};
		
		
		/**
		Window: orientation
		**/
		this.windowOrientationChange = function() {
			
		};


		this.isInView = function (
			_element,
			_position,
			scrollPercentRounded
		){

			/*
			Check if already triggered
			*/
			if(!_element.hasClass('triggered')) {

				/*
				Is Inview?
				*/
				if(_position.top < window.innerHeight && _position.bottom >= 0) {

					var _element_name	= _element.data('viewelement');
					_element.addClass("triggered");

					console.log('Trigger: ' + _element_name);
					
					/*
					Celenbrus
					*/
					window.celebrusSendJsonData(
				    	{"events":[
				    		{
				    			"eventType" 	: "PageDepthEvent",
				    			"eventGroup"	: "Scenario",

				    			"ViewDepth" 	: scrollPercentRounded,
				    			"ViewedElement"	: _element_name
				    		}
				    	]
					},2);

				}

			}

		};
		
}).apply(specific_interactions_window); 